export const LOAN_WITH_ANOTHER_LENDER = "LoanWithAnotherLender";

export const HAS_EXISTING_PAYMENT_PLAN = "true"